import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import { Modal } from "reactstrap";

function PreviewModal({ showPrev, closePrev, type, target }) {
	const [url, setUrl] = useState("");
	useEffect(() => {
		if (target) {
			console.log(
				"🚀 ~ file: PreviewModal.js ~ line 10 ~ useEffect ~ target",
				target
			);
			if (target.includes("https://")) {
				setUrl(target);
			} else if (target.includes("ipfs://")) {
				setUrl(`${process.env.REACT_APP_IPFS_HOST}/${target.slice(12)}`);
			}
		}
	}, [target]);

	return (
		<Box>
			{url && (
				<Modal
					centered
					fullscreen="xl"
					size={type?.includes("audio") ? "md" : "lg"}
					isOpen={showPrev}
					toggle={closePrev}
					style={{ maxHeight: "70vh" }}
				>
					{type?.includes("video") ? (
						<video autoPlay src={url} width="100%" height="auto" controls />
					) : type?.includes("audio") ? (
						<audio
							style={{
								display: "block",
								width: "100%",
								borderRadius: "none",
							}}
							autoPlay
							src={url}
							controls
						/>
					) : type?.includes("image") ? (
						<Box component="img" src={url} />
					) : type?.includes("pdf") ? (
						<iframe
							src={url}
							style={{ width: "100%", height: "70vh" }}
							frameBorder="0"
							title="PDF viewer"
						>
							Ваш браузер не поддерживает фреймы
						</iframe>
					) : type?.includes("msword") ? (
						<iframe
							src={`https://docs.google.com/viewer?url=${url}
                        &embedded=true `}
							style={{ width: "100%", height: "70vh" }}
							frameBorder="0"
							title="Docs previewer"
						>
							Ваш браузер не поддерживает фреймы
						</iframe>
					) : type?.includes("table") ? (
						<iframe
							src={`https://docs.google.com/viewer?url=${url}&embedded=true `}
							style={{ width: "100%", height: "70vh" }}
							frameBorder="0"
							title="Table previewer"
						>
							Ваш браузер не поддерживает фреймы
						</iframe>
					) : null}
				</Modal>
			)}
		</Box>
	);
}

export default PreviewModal;

{
	/* <iframe
    src={`https://docs.google.com/viewer?url=${url}&embedded=true `}
    style={{ width: '600px', height: '600px' }}
    frameBorder="0"
    title="Doc"
>
    Ваш браузер не поддерживает фреймы
</iframe>; */
}
